import * as Constant from "./Constant";
var metricDataType = ["NUMBER", "COST"];
var metricExceptId = [
    58,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    22,
    47,
    49,
    48,
    50,
    57,
    1,
    25,
    27,
    26,
];
var metricRoleAcceptField = [
    "request",
    "impression",
    "fill_rate",
    "click",
    "ctr",
    "cpc",
    "cpm",
    "cpm_per_imp",
    "total_revenue",
    "publisher_cpc",
    "pcpm",
    "pimp",
    "publisher_revenue",
    "payout_amount",
    "v_impression",
    "v_cpm",
    "publisher_v_cpm",
    "pv",
    "session_total_revenue",
    "pv_total_revenue"
];
export var metricRoleTrending = [
    { id: 51, defaultField: "publisher_cpm_trending" },
    { id: 52, defaultField: "publisher_cpm_per_imp_trending" },
    { id: 64, defaultField: "cpm_trending" },
    { id: 65, defaultField: "cpm_per_imp_trending" }
];
export var checkAccessMetric = function (metric) {
    if (metric && metric.defaultCollectionField) {
        var foundMetric = metricRoleAcceptField.find(function (metricField) {
            return metricField == metric.defaultCollectionField;
        });
        if (foundMetric)
            return true;
        return false;
    }
    return false;
};
export var buildMetrics = function (metrics, widgetCode) {
    if (!metrics || !metrics.length)
        return [];
    var metricTemps = metrics;
    switch (widgetCode) {
        case Constant.WIDGET_COMPOSED_CHART:
            metricTemps = metrics.filter(function (metric) {
                return metricDataType.indexOf(metric.dataType) >= 0;
            });
            break;
        case Constant.WIDGET_TOP_3_INCREASE:
            metricTemps = metrics.filter(function (metric) {
                return (metricDataType.indexOf(metric.dataType) >= 0 &&
                    metricExceptId.indexOf(metric.id) < 0);
            });
            break;
        case Constant.WIDGET_TOP_3_DECREASE:
            metricTemps = metrics.filter(function (metric) {
                return (metricDataType.indexOf(metric.dataType) >= 0 &&
                    metricExceptId.indexOf(metric.id) < 0);
            });
            break;
        case Constant.WIDGET_LINE_CHART:
            metricTemps = metrics.filter(function (metric) {
                return metricDataType.indexOf(metric.dataType) >= 0;
            });
            break;
        default:
            metricTemps = metrics;
            break;
    }
    return metricTemps;
};
